



























import Vue from "vue";
import Component from "vue-class-component";
import { ProgramPackTexts } from "../bookings/programPackTexts";
import { TodayLoader, TodayData } from "./todayData";
import ProgramPage from "../components/programs/ProgramPage.vue";
import GuidelineRow from "../components/guidelines/GuidelineRow.vue";
import { GuidelineApi } from "../components/guidelines/guidelineApi";
import GuidelineRecorder from "../components/guidelines/GuidelineRecorder.vue";
import CzCard from "../components/cz/CzCard.vue";
import CzTitle from "../components/cz/CzTitle.vue";
import CzRing from "../components/cz/CzRing.vue";
import CzPlanRow from "../components/cz/CzPlanRow.vue";
import CzLink from "../components/cz/CzLink.vue";

// Everything of the day in one list (D35), with what is done today in the header ring (D38). No week strip (D36).
@Component({
  components: { ProgramPage, GuidelineRow, GuidelineRecorder, CzCard, CzTitle, CzRing, CzPlanRow, CzLink },
})
export default class TodayPage extends Vue {
  data: TodayData = { today: "", rows: [], bookings: [], surveys: [], programs: [], programByGuideline: {} };
  loaded: boolean = false;
  busyId: number = 0;

  get total(): number {
    return TodayLoader.count(this.data);
  }

  get done(): number {
    return TodayLoader.done(this.data);
  }

  get ringLabel(): string {
    return this.$t("{0} of {1} done today").toString().replace("{0}", String(this.done)).replace("{1}", String(this.total));
  }

  get dateLabel(): string {
    if (!this.data.today) return "";
    return new Intl.DateTimeFormat(ProgramPackTexts.culture(), { weekday: "long", day: "numeric", month: "long" }).format(new Date(this.data.today + "T12:00:00"));
  }

  link(row: any): string {
    return GuidelineApi.link(row, "/today");
  }

  origin(row: any): string {
    const program = this.data.programByGuideline[row.id];
    return program ? this.$t("Program {0}").toString().replace("{0}", program) : this.$t("From your professional").toString();
  }

  time(start: string): string {
    return (start || "").substring(11, 16);
  }

  toggle(row: any) {
    (this.$refs.recorder as any).toggle(row);
  }

  updateRow(row: any) {
    this.data.rows = this.data.rows.map((r) => (r.id === row.id ? row : r));
  }

  async mounted() {
    this.data = await TodayLoader.load();
    this.loaded = true;
  }
}
